<template>
  <div>
    <mds-notification-container v-if="showAlert" class="alert-box-user">
      <mds-notification
        key="sizing-medium"
        size="medium"
        variation="error"
        :dismiss-delay="dismissVal"
        title="Unauthorized"
        role="alert"
        @mds-notification-dismissed="closePopup"
      >
        User has restricted access
      </mds-notification>
    </mds-notification-container>

    <div class="container">
      <section class="disclaimer-section">
        <h1 class="mds-level-6-heading">Disclaimer</h1>
        <div class="paragraph">
          Pursuant to SEC Rule 17g-5(a)(3) of the Exchange Act, Morningstar DBRS
          maintains certain information for rating actions taken on structured
          finance instruments covered under the Rule on this password-protected
          website and makes it available to NRSROs who meet the criteria to
          access it in accordance with the Rule.<br /><br />
          This website may only be viewed by an authorized representative of an
          organization that has been granted a username and password by
          Morningstar DBRS.<br /><br />
          To request access to this website, please send an email request to
          <a href="mailto:CreditCompliance@morningstar.com" class="my-link">
            CreditCompliance@morningstar.com
          </a>
          and include the certification set forth in Rule 17g-5(e).
        </div>

        <h2 class="mds-level-6-heading">Reporting Concerns</h2>
        <div class="paragraph">
          If an Authorized User experiences difficulties accessing transaction
          information on this website, or has concerns about the completeness or
          timeliness of information relating to transactions on the 17g5 list,
          please submit the concerns in writing to the Morningstar DBRS
          Designated Compliance Officer at
          <a href="mailto:CreditCompliance@morningstar.com" class="my-link">
            CreditCompliance@morningstar.com
          </a>
        </div>

        <div class="button-container">
          <mds-button
            variation="primary"
            size="medium"
            :disabled="isRedirecting"
            @click.prevent="redirectToLogin"
          >
            {{ isRedirecting ? "Redirecting..." : "Proceed To Sign In" }}
          </mds-button>
        </div>
      </section>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import {
  MdsNotification,
  MdsNotificationContainer,
} from "@mds/notification-vue3";
import { MdsButton } from "@mds/button-vue3";
import { redirectToCreditLogin } from "@/apis/user-authentication";

// Reactive state
const showAlert = ref(false);
const dismissVal = ref(300000);
const isRedirecting = ref(false);

// Lifecycle
onMounted(() => {
  window.addEventListener("beforeunload", removeStorage);

  if (localStorage.getItem("user_access")) {
    showAlert.value = true;
  }
});

onUnmounted(() => {
  window.removeEventListener("beforeunload", removeStorage);
});

// Methods
const redirectToLogin = async () => {
  try {
    isRedirecting.value = true;
    localStorage.removeItem("user_access");

    const successUrl = new URL(window.location.href + "deals-listing");
    redirectToCreditLogin(successUrl);
  } catch (error) {
    console.error("Login redirect error:", error);
    isRedirecting.value = false;
  }
};

const closePopup = () => {
  showAlert.value = false;
};

const removeStorage = () => {
  localStorage.removeItem("user_access");
};
</script>

<style lang="scss" scoped>
@import "@/styles/reset";
@import "@/styles/constants";

.container {
  margin-top: 82px;
  width: 620px;
  margin-left: auto;
  margin-right: auto;
  min-height: 500px;
  padding: $mds-space-2-x;
}

.disclaimer-section {
  .mds-level-6-heading {
    @include mds-level-6-heading();
    margin-bottom: $mds-space-3-x;
  }

  .paragraph {
    @include mds-body-text-s();
    margin-bottom: $mds-space-5-x;
    line-height: 1.6;
  }

  .button-container {
    display: flex;
    justify-content: center;
    margin-top: $mds-space-5-x;
  }
}

.alert-box-user {
  margin-top: $mds-masthead-height + $mds-space-3-x;
  max-width: 350px;
}

.mds-notification-container--top-center__mcr-rd {
  margin-left: auto;
  margin-right: auto;
}

// Responsive design
@media (max-width: 768px) {
  .container {
    width: 90%;
    margin-top: 60px;
    padding: $mds-space-2-x;
  }
}
</style>
